var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "water_mark_box" }, [
    _c("div", { staticClass: "half_box" }, [
      _c("div", { ref: "contractShowBox", staticClass: "contract_div" }, [
        _c("img", {
          staticClass: "img_src",
          attrs: { src: _vm.imgSrc, alt: "" }
        })
      ]),
      _c("canvas", {
        ref: "myCanvas",
        staticStyle: { display: "none" },
        attrs: { width: "300", height: "150" }
      }),
      _c("div", { staticClass: "water_mark" })
    ]),
    _c("div", { staticClass: "half_box" }, [
      _c("div", { staticClass: "water_main" }, [
        _c(
          "div",
          { staticClass: "water_text margin_bottom" },
          [
            _vm._m(0),
            _c("el-input", {
              attrs: {
                type: "textarea",
                placeholder: "请输入内容",
                maxlength: "30",
                "show-word-limit": "",
                size: "small"
              },
              on: { blur: _vm.getWaterMaker },
              model: {
                value: _vm.waterMarkText,
                callback: function($$v) {
                  _vm.waterMarkText = $$v
                },
                expression: "waterMarkText"
              }
            })
          ],
          1
        ),
        _c("ul", { staticClass: "font_color margin_bottom" }, [
          _c(
            "li",
            { staticClass: "font_color_li" },
            [
              _vm._m(1),
              _c(
                "el-select",
                {
                  attrs: { placeholder: "请选择", size: "small" },
                  model: {
                    value: _vm.waterParamObject.intFontSize,
                    callback: function($$v) {
                      _vm.$set(_vm.waterParamObject, "intFontSize", $$v)
                    },
                    expression: "waterParamObject.intFontSize"
                  }
                },
                _vm._l(_vm.fontSizeOptions, function(item) {
                  return _c("el-option", {
                    key: item.label,
                    attrs: { label: item.label, value: item.label }
                  })
                }),
                1
              )
            ],
            1
          ),
          _c(
            "li",
            { staticClass: "font_color_li" },
            [
              _vm._m(2),
              _c("el-color-picker", {
                attrs: {
                  "color-format": "rgb",
                  predefine: _vm.predefineColors,
                  size: "small"
                },
                model: {
                  value: _vm.waterParamObject.color,
                  callback: function($$v) {
                    _vm.$set(_vm.waterParamObject, "color", $$v)
                  },
                  expression: "waterParamObject.color"
                }
              })
            ],
            1
          )
        ]),
        _c("div", { staticClass: "transparent_set margin_bottom" }, [
          _vm._m(3),
          _c(
            "div",
            { staticClass: "transparent_item block" },
            [
              _c("el-slider", {
                staticClass: "slider_line",
                attrs: { size: "small" },
                model: {
                  value: _vm.waterParamObject.floatAlpha,
                  callback: function($$v) {
                    _vm.$set(_vm.waterParamObject, "floatAlpha", $$v)
                  },
                  expression: "waterParamObject.floatAlpha"
                }
              }),
              _c(
                "el-select",
                {
                  staticStyle: { width: "120px", "margin-left": "20px" },
                  attrs: { placeholder: "请选择", size: "small" },
                  model: {
                    value: _vm.waterParamObject.floatAlpha,
                    callback: function($$v) {
                      _vm.$set(_vm.waterParamObject, "floatAlpha", $$v)
                    },
                    expression: "waterParamObject.floatAlpha"
                  }
                },
                _vm._l(_vm.transparentOptions, function(item) {
                  return _c("el-option", {
                    key: item.value,
                    attrs: { label: item.label + "%", value: item.value }
                  })
                }),
                1
              )
            ],
            1
          )
        ]),
        _c("div", { staticClass: "water_address margin_bottom" }, [
          _vm._m(4),
          _c(
            "ul",
            { staticClass: "address_ul" },
            _vm._l(_vm.positionList, function(item, index) {
              return _c(
                "li",
                {
                  key: index,
                  class: [
                    "address_li",
                    item.class,
                    { active: item.value === _vm.waterParamObject.direction }
                  ],
                  on: {
                    click: function() {
                      _vm.waterParamObject.waterNum = item.value === 0 ? 4 : 2
                      _vm.waterParamObject.direction = item.value
                    }
                  }
                },
                [
                  item.value === 0
                    ? _vm._l(18, function(index) {
                        return _c("div", {
                          key: index,
                          staticClass: "more_tile_child"
                        })
                      })
                    : _c("div", { staticClass: "address_child" })
                ],
                2
              )
            }),
            0
          ),
          _c(
            "ul",
            { staticClass: "address_ul" },
            _vm._l(_vm.positionList, function(item) {
              return _c("li", { key: item.value, staticClass: "text_li" }, [
                _vm._v("\n            " + _vm._s(item.label) + "\n          ")
              ])
            }),
            0
          )
        ]),
        _c("ul", { staticClass: "font_color margin_bottom" }, [
          _c(
            "li",
            { staticClass: "font_color_li" },
            [
              _vm._m(5),
              _c(
                "el-select",
                {
                  attrs: { placeholder: "请选择", size: "small" },
                  model: {
                    value: _vm.waterParamObject.intDegree,
                    callback: function($$v) {
                      _vm.$set(_vm.waterParamObject, "intDegree", $$v)
                    },
                    expression: "waterParamObject.intDegree"
                  }
                },
                _vm._l(_vm.angleOption, function(item) {
                  return _c("el-option", {
                    key: item.value,
                    attrs: { label: item.label + "°", value: item.value }
                  })
                }),
                1
              )
            ],
            1
          ),
          _vm.waterParamObject.direction === 0
            ? _c(
                "li",
                { staticClass: "font_color_li" },
                [
                  _vm._m(6),
                  _c(
                    "el-select",
                    {
                      attrs: { placeholder: "请选择", size: "small" },
                      model: {
                        value: _vm.waterParamObject.waterNum,
                        callback: function($$v) {
                          _vm.$set(_vm.waterParamObject, "waterNum", $$v)
                        },
                        expression: "waterParamObject.waterNum"
                      }
                    },
                    _vm._l(_vm.densityOption, function(item) {
                      return _c("el-option", {
                        key: item.value,
                        attrs: { label: item.label, value: item.value }
                      })
                    }),
                    1
                  )
                ],
                1
              )
            : _vm._e()
        ]),
        _c(
          "footer",
          { staticClass: "footer_class" },
          [
            _c(
              "el-button",
              {
                attrs: { type: "primary", size: "small" },
                on: { click: _vm.addWaterSubmit }
              },
              [_vm._v("确定")]
            )
          ],
          1
        )
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "item_title" }, [
      _c("span", { staticClass: "start_color" }, [_vm._v("*")]),
      _vm._v("水印内容")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "item_title" }, [
      _c("span", { staticClass: "start_color" }, [_vm._v("*")]),
      _vm._v("字号")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "item_title" }, [
      _c("span", { staticClass: "start_color" }, [_vm._v("*")]),
      _vm._v("颜色")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "item_title" }, [
      _c("span", { staticClass: "start_color" }, [_vm._v("*")]),
      _vm._v("透明度")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "item_title" }, [
      _c("span", { staticClass: "start_color" }, [_vm._v("*")]),
      _vm._v("水印位置")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "item_title" }, [
      _c("span", { staticClass: "start_color" }, [_vm._v("*")]),
      _vm._v("水印角度")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "item_title" }, [
      _c("span", { staticClass: "start_color" }, [_vm._v("*")]),
      _vm._v("水印密度")
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2725c0c8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2725c0c8","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/waterMark/index.vue
// module id = ZKE4
// module chunks = 0 2 3 6 8 16 28 33 34 93 173